<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center"> {{ $t('globalTrans.'+title) }}
                </h5>
            </div>
        </template>
        <b-row class="mt-4">
            <!-- Area Type -->
            <b-col  lg="6" sm="12">
                <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="area_type_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('org_pro.area_type')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.area_type_id"
                            :options="areaTypeList"
                            id="area_type_id"
                            @change="getAreaTypeData(address.area_type_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="area_type_id_help area_type_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="area_type_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select the area type. This field is required.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="area_type_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Division -->
            <b-col lg="6" sm="12" >
                <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="division_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.division')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.division_id"
                            :options="divisionList"
                            id="division_id"
                            @change="changeDivisionId(address.division_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="division_id_help division_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="division_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a division. This field is required.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="division_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- District -->
            <b-col lg="6" sm="12">
                <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.district')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.district_id"
                            :options="districtList"
                            id="district_id"
                            @change="changeDistrictId(address.district_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="district_id_help district_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="district_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a district. This field is required.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="district_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- City Corporation -->
            <b-col lg="6" sm="12" v-show="cityCorporationShow">
                <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="city_corporation_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.city_corporation')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.city_corporation_id"
                            :options="cityCorporationList"
                            @change="changeWardId('city_corporation',address.city_corporation_id)"
                            id="city_corporation_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="city_corporation_id_help city_corporation_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="city_corporation_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a city corporation. This field is required if shown.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="city_corporation_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <!-- Upazila -->
            <b-col lg="6" sm="12" v-show="upazilaShow">
                <ValidationProvider name="Upazila" vid="upazilla_id" :rules="`${upazilaShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="upazilla_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.upazila')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.upazilla_id"
                            :options="upazilaList"
                            id="upazilla_id"
                            @change="changeUpazillaId(address.upazilla_id)"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="upazilla_id_help upazilla_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="upazilla_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select an upazila. This field is required if shown.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="upazilla_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Pourashava -->
            <b-col lg="6" sm="12" v-show="pourashavaShow">
                <ValidationProvider name="Pourashava" vid="pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="pauroshoba_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.pourashava')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.pauroshoba_id"
                            :options="pauroshobaList"
                            @change="changeWardId('pauroshoba',address.pauroshoba_id)"
                            id="pauroshoba_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="upazilla_id_help upazilla_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="pauroshoba_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a pourashava. This field is required if shown.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="pauroshoba_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Union -->
            <b-col lg="6" sm="12" v-show="unionShow">
                <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="union_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('hospital_public_panel.union')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.union_id"
                            :options="unionList"
                            @change="changeWardId('union',address.union_id)"
                            id="union_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="union_id_help union_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <!-- Help text -->
                        <b-form-text
                        id="union_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a union. This field is required if shown.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="union_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <!-- Ward -->
            <b-col lg="6" sm="12" v-show="wardShow">
                <ValidationProvider name="Ward" vid="ward_id" rules="">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="ward_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('org_pro.ward') }}
                            <span class="sr-only">(optional)</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.ward_id"
                            :options="wardList"
                            @change="dataReturn"
                            id="ward_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="false"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="ward_id_help ward_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                         <!-- Help text -->
                        <b-form-text
                        id="ward_id_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please select a ward. This field is optional.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="ward_id_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xl="6" lg="6" sm="12">
                <ValidationProvider name="Address (En)" vid="address_en" rules="required">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="address_en"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('grant_config.address_en')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="address.address"
                            @change="dataReturn"
                            id="address_en"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="address_en_help address_en_error"
                        ></b-form-input>
                        <!-- Help text -->
                        <b-form-text
                            id="address_en_help"
                            class="sr-only"
                            aria-live="polite"
                        >
                            Please enter your address in English. This field is required.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                            id="address_en_error"
                            class="invalid-feedback d-block"
                            role="alert"
                            aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xl="6" lg="6" sm="12">
                <ValidationProvider name="Address (Bn)" vid="address_bn" rules="required">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="address_bn"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{$t('grant_config.address_bn')}}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">(required)</span>
                        </template>
                        <b-form-input
                            class="form-control"
                            v-model="address.address_bn"
                            @change="dataReturn"
                            id="address_bn"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="address_bn_help address_bn_error"
                        ></b-form-input>
                        <!-- Help text -->
                        <b-form-text
                        id="address_bn_help"
                        class="sr-only"
                        aria-live="polite"
                        >
                        Please enter your address in Bangla. This field is required.
                        </b-form-text>

                        <!-- Error message -->
                        <div
                        id="address_bn_error"
                        class="invalid-feedback d-block"
                        role="alert"
                        aria-live="assertive"
                        >
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col lg="6" sm="12" v-if="service_name_check === 5">
            <!--
                <ValidationProvider name="Application To" vid="office_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="gdfg_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('externalUser.application_receiver_office') }} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.office_id"
                            :options="officeList"
                            @change="dataReturn"
                            id="office_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
             -->
            </b-col>
            <b-col lg="6" sm="12" v-else-if="service_name_check === 12">
                <ValidationProvider name="Application To" vid="office_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="gdfg_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('org_pro.office') }}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-select
                        disabled
                            plain
                            v-model="address.office_id"
                            :options="jpufHeadOffice"
                            id="office_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="office_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div
                            class="invalid-feedback"
                            id="office_id_error"
                            role="alert"
                            aria-live="assertive"
                        >
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
             <b-col lg="6" sm="12" v-else-if="service_name_check === 13">
                <ValidationProvider name="Application To" vid="office_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="gdfg_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('org_pro.office') }}
                            <span class="text-danger" aria-hidden="true">*</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-select
                        disabled
                            plain
                            v-model="address.office_id"
                            :options="jpufHeadOffice"
                            id="office_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                            aria-required="true"
                            :aria-invalid="errors.length ? 'true' : 'false'"
                            aria-describedby="office_id_error"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div
                            class="invalid-feedback"
                            id="office_id_error"
                            role="alert"
                            aria-live="assertive"
                        >
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col lg="6" sm="12" v-else>
                <ValidationProvider name="Application To" vid="office_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        label-for="gdfg_id"
                        slot-scope="{ valid, errors }"
                    >
                        <template v-slot:label>
                            {{ $t('org_pro.office') }}
                            <span class="text-danger" aria-hidden="true">*{{ service_name_check }}</span>
                            <span class="sr-only">required</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="address.office_id"
                            :options="officeList"
                            @change="dataReturn"
                            id="office_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate'
import Custom from '../../store/custom'

export default {
    props: ['org_id', 'title', 'data', 'service_name_check'],
    components: {
        ValidationProvider
    },
    data () {
        return {
            cityCorporationShow: false,
            upazilaShow: false,
            pourashavaShow: false,
            unionShow: false,
            wardShow: false,
            address: {
                division_id: 0,
                district_id: 0,
                area_type_id: 0,
                city_corporation_id: 0,
                upazilla_id: 0,
                pauroshoba_id: 0,
                union_id: 0,
                ward_id: 0,
                address: '',
                address_bn: '',
                office_id: 0
            },
            districtList: [],
            cityCorporationList: [],
            upazilaList: [],
            pauroshobaList: [],
            unionList: [],
            wardList: [],
            officeList: [],
            id: ''
        }
    },
    created () {
        if (this.service_name_check === 12) {
            this.address.office_id = 309
        }
        if (this.service_name_check === 13) {
            this.address.office_id = 309
        }
    },
    mounted () {
        if (this.data.area_type_id) {
            this.getAreaTypeData(parseInt(this.data.area_type_id))
            this.address = this.data
            this.districtList = this.getDistrictList()
            this.cityCorporationList = this.getCityCorporationList()
            this.upazilaList = this.getUpazilaList()
            this.pauroshobaList = this.getPauroshobaList()
            this.unionList = this.getUnionList()
            const areaType = parseInt(this.data.area_type_id)
            let type, id
            if (areaType === 1) {
                type = 'city_corporation'
                id = this.data.city_corporation_id
            } else if (areaType === 2) {
                type = 'pauroshoba'
                id = this.data.pauroshoba_id
            } else {
                type = 'union'
                id = this.data.union_id
            }
            this.changeWardId2(type, id)
            this.setOffice()
            this.dataReturn()
        }
    },
    watch: {
        org_id: function () {
            this.setOffice()
        },
        'address.area_type_id': function () {
            this.officeList = []
        },
        'address.division_id': function () {
            this.officeList = []
        },
        'address.district_id': function () {
            this.officeList = []
        },
        'address.upazilla_id': function () {
            this.officeList = []
        },
        'address.pauroshoba_id': function () {
            this.setOffice()
        },
        'address.city_corporation_id': function () {
            this.setOffice()
        },
        'address.union_id': function () {
            this.setOffice()
        },
        '$i18n.locale': function (newVal) {
            this.districtList = this.getDistrictList()
            this.cityCorporationList = this.getCityCorporationList()
            this.upazilaList = this.getUpazilaList()
            this.unionList = this.getUnionList()
            this.pauroshobaList = this.getPauroshobaList()
        }
    },
    computed: {
        areaTypeList () {
            const objectData = Custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        divisionList () {
            return this.$store.state.ExternalUser.commonObj.divisionList.filter(item => item.status === 0).map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        jpufHeadOffice: function () {
            return this.$store.state.ExternalUser.commonObj.officeList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    methods: {
        dataReturn () {
            this.$emit('address-data', this.address)
        },
        getAreaTypeData (typeId) {
            /**
             * 1 - City Corporation (City-Coporation, Ward)
             * 2 - Pauroshoba (Upazila, Pourosoba, Ward)
             * 3 - Union (Upazila, Pourosoba, Ward)
             */
            if (typeId === 1) {
                /** City Corporation */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = true
                this.upazilaShow = false
                this.pourashavaShow = false
                this.unionShow = false
                this.wardShow = true
            } else if (typeId === 2) {
                /** Pauroshoba */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = true
                this.pourashavaShow = true
                this.unionShow = false
                this.wardShow = true
            } else if (typeId === 3) {
                /** Union */
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = true
                this.pourashavaShow = false
                this.unionShow = true
                this.wardShow = true
            } else {
                // Resetting The Form & Data
                this.address.city_corporation_id = 0
                this.address.upazilla_id = 0
                this.address.pauroshoba_id = 0
                this.address.union_id = 0
                this.address.ward_id = 0
                this.cityCorporationShow = false
                this.upazilaShow = false
                this.pourashavaShow = false
                this.unionShow = false
                this.wardShow = false
            }
            /** Updating cityCorporationList & upazilaList */
            this.cityCorporationList = this.getCityCorporationList(this.address.district_id)
            this.upazilaList = this.getUpazilaList(this.address.district_id)
            this.dataReturn()
        },
        getDistrictList (divisionId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.districtList.filter(item => item.status === 0 && item.division_id === parseInt(this.address.division_id))
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getCityCorporationList (districtId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === parseInt(this.address.district_id))
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getUpazilaList (districtId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === parseInt(this.address.district_id))
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getUnionList (upazillaId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === parseInt(this.address.upazilla_id))
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getPauroshobaList (upazillaId = null) {
            const objectData = this.$store.state.ExternalUser.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === parseInt(this.address.upazilla_id))
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        changeWardId (areaType, id) {
            this.address.ward_id = 0
            const objectData = this.$store.state.ExternalUser.commonObj.wardList
            objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
            if (areaType === 'city_corporation') this.wardList = objectData.filter(item => item.city_corporation_id === id)
            else if (areaType === 'pauroshoba') this.wardList = objectData.filter(item => item.pauroshoba_id === id)
            else this.wardList = objectData.filter(item => item.union_id === id)
            this.dataReturn()
        },
        changeWardId2 (areaType, id) {
            const objectData = this.$store.state.ExternalUser.commonObj.wardList
            objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
            if (areaType === 'city_corporation') this.wardList = objectData.filter(item => item.city_corporation_id === id)
            else if (areaType === 'pauroshoba') this.wardList = objectData.filter(item => item.pauroshoba_id === id)
            else this.wardList = objectData.filter(item => item.union_id === id)
            this.dataReturn()
        },
        changeDivisionId (divisionId) {
            this.address.district_id = 0
            this.districtList = this.getDistrictList(divisionId)
            this.dataReturn()
        },
        changeDistrictId (districtId) {
            this.address.city_corporation_id = 0
            this.address.upazilla_id = 0
            this.cityCorporationList = this.getCityCorporationList(districtId)
            this.upazilaList = this.getUpazilaList(districtId)
            this.dataReturn()
        },
        changeUpazillaId (upazillaId) {
            this.address.pauroshoba_id = 0
            this.address.union_id = 0
            this.pauroshobaList = this.getPauroshobaList(upazillaId)
            this.unionList = this.getUnionList(upazillaId)
            this.dataReturn()
        },
        setOffice () {
            const officeList = this.$store.state.ExternalUser.commonObj.officeList.filter((office) => office.org_id === this.org_id)
            let tmpOfficeList = []
            if (parseInt(this.address.area_type_id) === 1) {
                if (parseInt(this.address.city_corporation_id) > 0 && parseInt(this.address.district_id) > 0 && parseInt(this.address.division_id) > 0) {
                    const check1 = officeList.filter(office => office.city_corporation_id === parseInt(this.address.city_corporation_id))
                    if (check1.length > 0) {
                        tmpOfficeList = check1
                    } else {
                        const check2 = officeList.filter(office => office.district_id === parseInt(this.address.district_id))
                        if (check2.length > 0) {
                            tmpOfficeList = check2
                        } else {
                            tmpOfficeList = officeList.filter(office => office.division_id === parseInt(this.address.division_id))
                        }
                    }
                }
            } else if (parseInt(this.address.area_type_id) === 2) {
                if (parseInt(this.address.pauroshoba_id) > 0 && parseInt(this.address.upazilla_id) > 0 && parseInt(this.address.district_id) > 0 && parseInt(this.address.division_id) > 0) {
                    const check1 = officeList.filter(office => office.pauroshoba_id === parseInt(this.address.pauroshoba_id))
                    if (check1.length > 0) {
                        tmpOfficeList = check1
                    } else {
                        const check2 = officeList.filter(office => office.upazilla_id === parseInt(this.address.upazilla_id))
                        if (check2.length > 0) {
                            tmpOfficeList = check2
                        } else {
                            const check3 = officeList.filter(office => office.district_id === parseInt(this.address.district_id))
                            if (check3.length > 0) {
                                tmpOfficeList = check3
                            } else {
                                tmpOfficeList = officeList.filter(office => office.division_id === parseInt(this.address.division_id))
                            }
                        }
                    }
                }
            } else {
                if (parseInt(this.address.union_id) > 0 && parseInt(this.address.upazilla_id) > 0 && parseInt(this.address.district_id) > 0 && parseInt(this.address.division_id) > 0) {
                    const check1 = officeList.filter(office => office.union_id === parseInt(this.address.union_id))
                    if (check1.length > 0) {
                        tmpOfficeList = check1
                    } else {
                        const check2 = officeList.filter(office => office.upazilla_id === parseInt(this.address.upazilla_id))
                        if (check2.length > 0) {
                            tmpOfficeList = check2
                        } else {
                            const check3 = officeList.filter(office => office.district_id === parseInt(this.address.district_id))
                            if (check3.length > 0) {
                                tmpOfficeList = check3
                            } else {
                                tmpOfficeList = officeList.filter(office => office.division_id === parseInt(this.address.division_id))
                            }
                        }
                    }
                }
            }

            if (tmpOfficeList) {
                this.officeList = tmpOfficeList.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            }
        }
    }
}
</script>
